import {
  amendEditOrderToCustomerMessages_DETAILS,
  amendEditOrderToCustomerMessages_SUMMARY,
  deleteEditOrderFromCustomerMessages,
} from 'apps/customerMessages/actions/customerMessages';
import { config } from 'api';
import fetchAction from 'utils/fetchAction';

const urlOrdersSummary = `${config.apiBasePath}/orders/summary`;
const urlOrderDetails = `${config.apiBasePath}/orders/{ID}/tracking`;

export const FETCH_ORDERS_SUMMARY_REQUEST = 'FETCH_ORDERS_SUMMARY_REQUEST';
export const FETCH_ORDERS_SUMMARY_SUCCESS = 'FETCH_ORDERS_SUMMARY_SUCCESS';
export const FETCH_ORDERS_SUMMARY_ERROR = 'FETCH_ORDERS_SUMMARY_ERROR';

export const FETCH_ORDER_DETAILS_REQUEST = 'FETCH_ORDER_DETAILS_REQUEST';
export const FETCH_ORDER_DETAILS_SUCCESS = 'FETCH_ORDER_DETAILS_SUCCESS';
export const FETCH_ORDER_DETAILS_ERROR = 'FETCH_ORDER_DETAILS_ERROR';

export const fetchOrdersSummary = fetchAction({
  actions: [
    FETCH_ORDERS_SUMMARY_REQUEST,
    FETCH_ORDERS_SUMMARY_SUCCESS,
    FETCH_ORDERS_SUMMARY_ERROR,
  ],
  url: urlOrdersSummary,
  onSuccess: [amendEditOrderToCustomerMessages_SUMMARY],
  onError: [deleteEditOrderFromCustomerMessages],
});

export const fetchOrderDetails = id => fetchAction({
  actions: [
    FETCH_ORDER_DETAILS_REQUEST,
    FETCH_ORDER_DETAILS_SUCCESS,
    FETCH_ORDER_DETAILS_ERROR,
  ],
  url: urlOrderDetails.replace('{ID}', id),
  onSuccess: [amendEditOrderToCustomerMessages_DETAILS],
  onError: [deleteEditOrderFromCustomerMessages],
});
